import { supabaseClient as supabase } from 'supabase/supabase'

export async function assignCreativesToCampaign(
  campaignId: string,
  creativeIds: string[]
) {
  try {
    const assignments = creativeIds.map((creativeId) => ({
      campaign_id: campaignId,
      creative_id: creativeId
    }))

    const { data, error } = await supabase
      .from('campaign_creatives')
      .insert(assignments)
      .select()

    if (error) throw error
    return { data, error: null }
  } catch (error) {
    console.error('Error assigning creatives to campaign:', error)
    return { data: null, error }
  }
}

export async function getCampaignCreatives(campaignId: string) {
  try {
    const { data, error } = await supabase
      .from('campaign_creatives')
      .select(`
        id,
        campaign_id,
        creative_id,
        created_at,
        creatives (
          id,
          advertiser_id,
          title,
          description,
          card_image_url,
          detail_image_url,
          created_at,
          updated_at
        )
      `)
      .eq('campaign_id', campaignId)
      .order('created_at', { ascending: false })

    if (error) throw error
    return { data, error: null }
  } catch (error) {
    console.error('Error fetching campaign creatives:', error)
    return { data: null, error }
  }
}

export async function removeCampaignCreative(
  campaignId: string,
  creativeId: string
) {
  try {
    const { error } = await supabase
      .from('campaign_creatives')
      .delete()
      .eq('campaign_id', campaignId)
      .eq('creative_id', creativeId)

    if (error) throw error
    return { error: null }
  } catch (error) {
    console.error('Error removing creative from campaign:', error)
    return { error }
  }
}

// Every creative now carries both a 1:1 card image and a 16:9 detail image, so
// it is usable in any campaign slot — there is no aspect-ratio matching to do.
export async function getAvailableCreativesForCampaign(advertiserId: string) {
  try {
    const { data, error } = await supabase
      .from('creatives')
      .select('*')
      .eq('advertiser_id', advertiserId)
      .order('created_at', { ascending: false })

    if (error) throw error
    return { data, error: null }
  } catch (error) {
    console.error('Error fetching available creatives:', error)
    return { data: null, error }
  }
}